module.exports = __webpack_public_path__ + "static/media/mudeyGreyNew.516713a5.png";